import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 28,
    fontSize: 10,
    color: '#111111',
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  company: {
    flex: 1,
    paddingRight: 12,
  },
  companyName: {
    fontSize: 16,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
  },
  muted: {
    color: '#555555',
    marginBottom: 2,
  },
  invoiceMeta: {
    width: 160,
    textAlign: 'right',
  },
  invoiceTitle: {
    fontSize: 16,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
  },
  logo: {
    width: 90,
    height: 48,
    objectFit: 'contain',
    marginBottom: 6,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  col: {
    flex: 1,
    paddingRight: 10,
  },
  sectionTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
    marginBottom: 4,
    textTransform: 'uppercase',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f4f6f8',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    paddingVertical: 6,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eeeeee',
    paddingVertical: 6,
  },
  cellDesc: { width: '50%', paddingRight: 6 },
  cellQty: { width: '12%', textAlign: 'center' },
  cellMoney: { width: '19%', textAlign: 'right' },
  bold: { fontFamily: 'Helvetica-Bold' },
  totals: {
    marginTop: 12,
    marginLeft: 'auto',
    width: 180,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  notes: {
    marginTop: 16,
    borderWidth: 1,
    borderColor: '#dddddd',
    padding: 8,
    minHeight: 40,
  },
  footer: {
    marginTop: 18,
    textAlign: 'center',
    color: '#555555',
    fontSize: 9,
  },
});

export default styles;
